export default {
  'transferTemplate.templateName': 'Template Name',
  'transferTemplate.add': 'Create New Template',
  'transferTemplate.deleteWarning': 'Delete Transfer Template',
  'transferTemplate.content': 'template(s) will be deleted and will be permanently removed.',
  'transferTemplate.initiateTransfer': 'Initiate Transfer',
  'transferTemplate.deleteSuccessMessage': 'Template(s) successfully deleted',
  'transferTemplate.deleteErrorMessage': 'Template(s) were not deleted',
  'transferTemplate.createSuccessMessage': 'Template successfully created',
  'transferTemplate.createErrorMessage': 'Template(s) were not created',
  'transferTemplate.modifySuccessMessage': 'Template(s) successfully updated',
  'transferTemplate.initiateSuccessMessage': 'Transfer Successful!',
  'transferTemplate.updateErrorMessage': 'Template(s) were not updated',
  'transferTemplate.initiatePendingMessage': "Transfer Initiated and is awaiting other's approval."
};
